import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, } from 'react-router-dom';
import Login from './Component/Login';
import DashBoard from './Component/DashBoard';
import AddPatient from './Screen/AddPatient';
import AdminDashboard from './Screen/AdminDashboard';
import PatientList from './Screen/PatientList';
import EditPatient from './Screen/EditPatient';
import AddCase from '../src/Screen/AddCase'
import EditCase from './Screen/EditCase';
import AddFile from './Screen/AddFile';
import CaseList from './Screen/CaseList';
import { AppProvider, useGlobalContext, } from './Component/Context';
import Rout from './Component/Rout';
import { Navigate } from 'react-router-dom';
import PageNotFound from './Screen/PageNotFound';

function App() {
  const { isLoggedIn } = useGlobalContext();


  useEffect(() => {
    console.log(isLoggedIn)
  })

  return (
    <div className="App">
      <Routes>
        {
          isLoggedIn ? (
            <>
              <Route path="/dashboard" element={<DashBoard />} />
              <Route path="/add-patient" element={<AddPatient />} />
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/patient-list" element={<PatientList />} />
              <Route path="/edit-patient/:uid" element={<EditPatient />} />
              <Route path="/add-case/:uid" element={<AddCase />} />
              <Route path="/edit-case" element={<EditCase />} />
              <Route path="/add-file/:uid" element={<AddFile />} />
              <Route path="/case-list" element={<CaseList />} />
            </>
          ) :
            <>
             
              <Route path='*' element={<Login />} />
          </>

           
        }
      </Routes>

    </div>
  );
}

export default App;
